import { AnyAction } from 'redux';
import { SUGGEST_ACTIONS } from 'src/actions/SuggestActions';
import { SEARCH_ACTIONS } from 'src/actions/SearchActions';

export function queryReducer(
    state: string,
    action: AnyAction,
): string {
    if (SEARCH_ACTIONS.isPending(action)) {
        return action.meta.query;
    }
    if (SUGGEST_ACTIONS.isPending(action)) {
        return action.meta;
    }

    return state;
}
